import styled from "styled-components";
import {
  Page,
  PrimaryButton,
  FlexContainer,
  GradientText,
} from "../../components/styled";
import MarketItem from "../../components/marketItem";
import NovaIcon from "../../assets/images/logo/tokens/nova.png";
import CptIcon from "../../assets/images/logo/tokens/cpt.png";
import { getProducts } from "../../service/main/api";
import React, { useEffect, useState } from "react";
import { useLoading } from "../../context/LoadingContext";
import { useBottomSheet } from "../../context/BottomSheetContext";
import MarketbuyConfirmModalContent from "../../components/marketBuyConfirmModalContent";
// import {createMarketTransaction} from "../../service/main/api";
import { useToaster } from "../../hooks/useToaster";
// import { useNavigate } from "react-router-dom";
import useNovaPrice from "../../hooks/useNovaPrice";
import { formatNumber ,formatEthers} from "../../utils";
import { useUserContext } from "../../context/UserContext";
import { useAccount ,useSwitchChain} from "wagmi";
import { BSC_CHAIN_ID } from "../../service/web3/wagmi";
import {
  checkTokenAllowance,
  approveToken,
  buyCartWithQuote,
} from "../../service/web3/checkout";
import { MaxUint256 } from "ethers";
import { createCheckOutTransaction } from "../../service/main/api";
import { useNavigate } from "react-router-dom";

const Market = () => {
  const [products, setProducts] = useState([]);
  const [basketItems, setBasketItems] = useState([]);
  const [groupedBasketItems, setGroupedBasketItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const { setIsLoading } = useLoading();
  const { openSheet, closeSheet } = useBottomSheet();
  const { priceNumber } = useNovaPrice();
  const [approved, setApproved] = useState(false);
  const navigate = useNavigate();

  const { user } = useUserContext();
  const connectedAddress = user?.walletAddress || "";
  const { chainId: accountChainId } = useAccount();
  const { switchChainAsync, isPending: isSwitching } = useSwitchChain();
  useEffect(() => {
    const checkAllowance = async () => {
      if (!connectedAddress) return;
      if (accountChainId !== BSC_CHAIN_ID) {
        try {          await switchChainAsync({ chainId: BSC_CHAIN_ID });
        } catch (error) {
          console.error("Failed to switch chain:", error);
          return;
        }
      };
      const response = await checkTokenAllowance({
        owner: connectedAddress,
        spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
        tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
        requiredAmount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
      });
      if (response.success) {
        setApproved(response.data.isEnough);
      } else {
        console.error("Failed to check token allowance:", response.error);
      }
    };
    checkAllowance();
  }, [connectedAddress, accountChainId]);
  const { showToaster } = useToaster();

  useEffect(() => {
    const handleProducts = async () => {
      setIsLoading(true);
      const response = await getProducts({
        modelTypes: [
          "Ticket",
          "Enhancer",
          "Token",
          "LotteryTicketItem",
          "EnergyItem",
        ],
      });
      if (!response?.success) {
        setIsLoading(false);
        return;
      }
      setProducts(response.data);
      setIsLoading(false);
    };
    handleProducts();
  }, []);

  const handleBasket = (product, action, amount) => {
    if (
      product?.currency?.symbol === "CPT" &&
      basketItems.some((i) => i.currency?.symbol === "NOVA")
    ) {
      showToaster({
        type: "error",
        message:
          "You can not add CPT and NOVA items to the basket at the same time.",
      });
      return false;
    }
    if (
      product?.currency?.symbol === "NOVA" &&
      basketItems.some((i) => i.currency?.symbol === "CPT")
    ) {
      showToaster({
        type: "error",
        message:
          "You can not add CPT and NOVA items to the basket at the same time.",
      });
      return false;
    }
    if (action === "custom") {
      console.log("amount", amount);
      let items = [...basketItems];
      items = items.filter((i) => i.item.name !== product.item.name);
      let price = 0;
      items.forEach((i) => {
        price += i.price;
      });
      for (let i = 0; i < amount; i++) {
        items.push(product);
      }
      setBasketItems([...items]);
      setTotalPrice(
        round5(price + (product.priceInUsd / priceNumber) * amount),
      );
      setGroupedBasketItems(groupItems([...items]));
      return true;
    }
    if (action === "remove") {
      let index = basketItems.indexOf(product);
      if (index > -1) {
        basketItems.splice(index, 1);
        setTotalPrice(round5(totalPrice - product.priceInUsd / priceNumber));
        setBasketItems([...basketItems]);
        setGroupedBasketItems(groupItems([...basketItems]));
      }
      return true;
    }
    setTotalPrice(round5(totalPrice + product.priceInUsd / priceNumber));
    setBasketItems([...basketItems, product]);
    setGroupedBasketItems(groupItems([...basketItems, product]));
    return true;
  };
  const round5 = (num) => {
    return Math.round(num * 1e5) / 1e5;
  };

  const groupItems = (items) => {
    const groupedProducts = items.reduce((acc, product) => {
      const key = product.item.name;
      if (!acc[key]) {
        acc[key] = { ...product, count: 1 };
      } else {
        acc[key].count++;
      }
      return acc;
    }, {});
    return Object.values(groupedProducts);
  };
  const openConfirmModal = async () => {
    if (basketItems.length === 0) return;
    const groupedProducts = groupItems(basketItems);
    setIsLoading(true);
    const basket = groupedProducts.map((product) => ({
      productId: product.productId,
      quantity: product.count,
      productName: product.item.name,
      productImage: product.item.imageUri,
    }));
    const res = await createCheckOutTransaction({
      basket: basket,
    });
    if (!res.success) {
      console.error("Failed to create checkout transaction:", res.error);
      showToaster({
        type: "error",
        message: "Failed to create checkout transaction. Please try again.",
      });
      setIsLoading(false);
      return;
    }
    console.log("Checkout transaction created successfully:", res.data);
    setIsLoading(false);
    //  openSheet({
    //    content: (
    //      <MarketbuyConfirmModalContent
    //        navigate={navigate}
    //        onClose={handleOnClose}
    //        onConfirm={() => handleConfirm({
    //         items:[
    //           {
    //             productId: product.productId,
    //             quantity: amount,
    //           }
    //         ],
    //         quote: res.data.quote,
    //         signature: res.data.signature,
    //        })}
    //        totalCost={formatEthers(res.data.quote.tokenAmount)}
    //        products={[{...product,count:amount}]}
    //      />
    //    )
    //  });
    openSheet({
      content: (
        <MarketbuyConfirmModalContent
          onConfirm={() => handleConfirm({
            items: groupedProducts.map((product) => ({
              productId: product.productId,
              quantity: product.count,
            })),
            quote: res.data.quote,
            signature: res.data.signature,
          })}
          totalCost={formatEthers(res.data.quote.tokenAmount)}
          currency={basketItems[0].currency.symbol}
          onClose={closeSheet}
          products={groupedProducts}
        />
      ),
    });
  };
  const handleApprove = async () => {
    setIsLoading(true);
    const response = await approveToken({
      tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
      spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
      amount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
    });
    if (response.success) {
      showToaster({ type: "success", message: "Approval successful!" });
      setApproved(true);
    } else {
      console.error("Failed to approve token:", response.error);
      showToaster({
        type: "error",
        message: "Approval failed. Please try again.",
      });
    }
    setIsLoading(false);
  };
  const handleConfirm = async (data) => {
    setIsLoading(true);
    const buyRes = await buyCartWithQuote(data);
    if (buyRes.success) {
      console.log("Purchase successful:", buyRes.data);
      showToaster({ type: "success", message: "Purchase successful!,Keep check in order history" });
      handleOnClose("success");
    } else {
      console.error("Failed to complete purchase:", buyRes.error);
      showToaster({
        type: "error",
        message: "Purchase failed. Please try again.",
      });
      handleOnClose();
    }
    setIsLoading(false);
  };

  const handleOnClose = (status) => {
    closeSheet();
    if (status === "success") {
      setBasketItems([]);
      setGroupedBasketItems([]);
      setTotalPrice(0);
            navigate("/orders");
    }
  };
  return (
    <StyledPage>
      <ItemsContainer>
        {React.Children.toArray(
          products.map((product) => (
            <MarketItem
              novaPrice={priceNumber}
              handleBasket={handleBasket}
              product={product}
            />
          )),
        )}
      </ItemsContainer>
      <MarketFooterContainer>
        <BasketArea>
          {React.Children.toArray(
            groupedBasketItems.map((product) => (
              <BasketItem>
                <img
                  style={{ width: "44px" }}
                  src={product.item.imageUri}
                  alt={product.item.name}
                />
                <GradientText
                  color="linear-gradient(0deg, #886EE0, #886EE0),linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)"
                  style={{ fontSize: "16px", fontWeight: 600 }}
                >
                  {product.count}x
                </GradientText>
              </BasketItem>
            )),
          )}
        </BasketArea>
        <PrimaryButton
          onClick={approved ? openConfirmModal : handleApprove}
          style={{ height: "60px" }}
        >
          {approved ? (
            <FlexContainer gap="8px">
              {basketItems.length &&
              basketItems.some((i) => i.currency?.symbol === "CPT") ? (
                <img style={{ width: "32px" }} src={CptIcon} alt="CPT Icon" />
              ) : (
                <img style={{ width: "32px" }} src={NovaIcon} alt="Nova Icon" />
              )}
              <span
                style={{ color: "white", fontSize: "24px", fontWeight: 600 }}
              >
                {formatNumber(totalPrice)}
              </span>
            </FlexContainer>
          ) : (
            "Approve"
          )}
        </PrimaryButton>
      </MarketFooterContainer>
    </StyledPage>
  );
};

const StyledPage = styled(Page)`
  padding-bottom: 0;
`;
const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  overflow-y: auto;
  padding-top: 24px;
  padding-bottom: calc(217px + var(--tg-safe-area-inset-bottom, 0px));
`;
const MarketFooterContainer = styled.div`
  width: 100%;
  max-width: 420px;
  height: calc(175px + var(--tg-safe-area-inset-bottom, 0px));
  padding: 16px;
  padding-bottom: calc(32px + var(--tg-safe-area-inset-bottom, 0px));
  background: #5b5b5b26;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  position: fixed;
  bottom: 0;
  border-top-left-radius: 38px;
  border-top-right-radius: 38px;
`;
const BasketArea = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 32px;
  margin-top: 8px;
  margin-bottom: 16px;
  height: 50px;
`;
const BasketItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export default Market;
